module.exports = __webpack_public_path__ + "media/images/icon-nohistorical-87ca453e7c9764cada475d121e7cbfc1.png";